import { useGlobalState } from '../../../state/state';
import { getMembershipTitle } from '../../../utils/stringHelper';
import { Pages } from '../../../utils/constants';
import { MembershipLevel } from '@ace-clublabs/common-membership-api-types';
import {
  IManageMembershipItemProps,
  ManageMembershipItem,
  ManageMembershipItemButton,
  ManageMembershipItemInfo,
} from '../ManageMembershipItem/ManageMembershipItem';
import { useHistory } from 'react-router-dom';
import { Typography } from '@ace-clublabs/shared-component-library';

export const BenefitLevel = () => {
  const history = useHistory();

  const [membershipDetails] = useGlobalState('memberDetails');
  const [formData] = useGlobalState('formData');

  const { benefitLevels } = membershipDetails;

  const getDisplayBenefitLevel = () => {
    const currentBenefitLevel = benefitLevels?.existingLevel;
    const requestedBenefitLevel = formData.requestedMembershipLevel;
    if (requestedBenefitLevel && currentBenefitLevel !== requestedBenefitLevel) {
      return requestedBenefitLevel;
    } else {
      return currentBenefitLevel;
    }
  };

  const displayBenefitLevel = getDisplayBenefitLevel();

  const isUpdatingBenefitLevel =
    formData.requestedMembershipLevel && benefitLevels?.existingLevel! !== formData.requestedMembershipLevel;

  const isUpgradingBenefitLevel = () => {
    if (!isUpdatingBenefitLevel) return false;
    switch (benefitLevels?.existingLevel) {
      case MembershipLevel.CLASSIC:
        return [MembershipLevel.PLUS, MembershipLevel.PREMIER].includes(
          formData?.requestedMembershipLevel as MembershipLevel
        );
      case MembershipLevel.PLUS:
        return [MembershipLevel.PREMIER].includes(formData?.requestedMembershipLevel as MembershipLevel);
      default:
        return false;
    }
  };

  const getBenefitLevelItems = () => {
    const benefitLevelItems: IManageMembershipItemProps['items'] = [
      {
        type: 'info',
        title: <>{getMembershipTitle(membershipDetails, displayBenefitLevel, undefined, formData)} member</>,
        subtitle: isUpgradingBenefitLevel() ? (
          <Typography variant="b3Regular">
            Changes <strong>will be effective seven (7) days</strong> after full payment is received.{' '}
          </Typography>
        ) : undefined,
        className: 'benefit-level',
        key: 'benefit-level',
        rightIconName: isUpdatingBenefitLevel ? 'pen-regular' : undefined,
        rightIconOnClick: isUpdatingBenefitLevel ? () => history.push(Pages.ChangeBenefitLevelPage) : undefined,
      } as ManageMembershipItemInfo,
    ];
    if (!isUpdatingBenefitLevel) {
      benefitLevelItems.push({
        type: 'button',
        text: benefitLevels?.existingLevel === MembershipLevel.CLASSIC ? 'Upgrade' : 'Change',
        onClick: () => {
          history.push(Pages.ChangeBenefitLevelPage);
        },
        iconName: 'plus-regular',
        className: `manage-membership-button-benefit-level`,
      } as ManageMembershipItemButton);
    }
    return benefitLevelItems;
  };

  return (
    <ManageMembershipItem
      sectionTitle="Benefit level"
      iconName="card-membership-duotone"
      titleClassName="benefit-level"
      items={getBenefitLevelItems()}
    />
  );
};
